const translations = {
  "en": {
    "Connect your broker": "Connect your broker",
    "Connect your broker, read-only, and I'll show you which of your funds are buying the same companies. A screenshot works too.": "Connect your broker, read-only, and I'll show you which of your funds are buying the same companies. A screenshot works too.",
    "Example · VOO + VTI": "Example · VOO + VTI",
    "Go back": "Go back",
    "How much do my funds overlap?": "How much do my funds overlap?",
    "I'll open every fund you hold and show you which companies you're buying more than once.": "I'll open every fund you hold and show you which companies you're buying more than once.",
    "Let me look inside your funds.": "Let me look inside your funds.",
    "Let's see how much your funds overlap.": "Let's see how much your funds overlap.",
    "overlap": "overlap",
    "Read-only. I never move money.": "Read-only. I never move money.",
    "Signed in": "Signed in",
    "Signed in.": "Signed in.",
    "Upload a screenshot instead": "Upload a screenshot instead"
  },
  "zh-tw": {
    "Connect your broker": "連結您的券商",
    "Connect your broker, read-only, and I'll show you which of your funds are buying the same companies. A screenshot works too.": "僅限唯讀模式連線您的券商，我將為您顯示哪些基金正在投資相同公司。提供截圖亦可。",
    "Example · VOO + VTI": "範例 · VOO + VTI",
    "Go back": "返回",
    "How much do my funds overlap?": "您的基金重疊程度為何？",
    "I'll open every fund you hold and show you which companies you're buying more than once.": "我將逐一檢視您持有的所有基金，並為您標示出重複持有的公司。",
    "Let me look inside your funds.": "讓我為您深入檢視基金內容。",
    "Let's see how much your funds overlap.": "來看看您的基金重疊程度。",
    "overlap": "重疊",
    "Read-only. I never move money.": "唯讀。我絕不會動用資金。",
    "Signed in": "已登入",
    "Signed in.": "已登入。",
    "Upload a screenshot instead": "改為上傳截圖"
  }
};

export default translations;
